import { startOfWeek } from "date-fns/startOfWeek";
import type { DirectSubroutesOf } from "../../routing";
import { ALL_CALENDAR_VIEW_ID } from "../../hooks/useCalendarTableViews";

export interface BuildCalendarPathOptions {
  viewType?: DirectSubroutesOf<"/calendar/view/:viewId">;
  fallbackViewType: DirectSubroutesOf<"/calendar/view/:viewId">;
  date: Date | "today";
  viewId?: string;
  fallbackViewId?: string;
  params?: { viewId?: string; year?: string; month?: string; day?: string };
}

export const buildCalendarPath = ({
  viewType,
  fallbackViewType,
  date,
  viewId,
  fallbackViewId,
  params,
}: BuildCalendarPathOptions): string => {
  const effectiveViewType = viewType ?? fallbackViewType;
  const effectiveViewId = viewId ?? params?.viewId ?? fallbackViewId ?? ALL_CALENDAR_VIEW_ID;
  const baseDate = date !== "today" ? date : viewType === "week" ? startOfWeek(new Date()) : new Date();

  const year = params?.year ?? String(baseDate.getFullYear());
  const month = params?.month ?? String(baseDate.getMonth());
  const day = params?.day ?? String(baseDate.getDate());

  const pathSegments: string[] = ["/calendar", "view", effectiveViewId, effectiveViewType, year];

  switch (viewType) {
    case "month":
    case "list":
      pathSegments.push(month);
      break;
    case "day":
    case "week":
      pathSegments.push(month);
      pathSegments.push(day);
      break;
  }

  return pathSegments.join("/");
};
